<template>
  <div class="middle-bottom">
    <div class="mhead">
      <div class="item" @click="on_change(2)" :class="active == 2 ? 'active' : ''">参与情况</div>
      <div class="item" @click="on_change(1)" :class="active == 1 ? 'active' : ''">工会排行</div>
    </div>
    <div class="table" v-if="active == 1">
      <div class="thead">
        <div class="i-item grank">排行</div>
        <div class="i-item gname">工会名称</div>
        <div class="i-item kcal">参与人次</div>
      </div>
      <div class="tbody" :class="count <= 5 ? 'high' : ''">
        <transition-group name="list" tag="div">
          <div class="item" v-for="(item, i) in c_list" :key="i">
            <div class="i-item grank">{{ i + 1 + p_step * page_size }}</div>
            <div class="i-item gname">{{ item.name }}</div>
            <div class="i-item kcal">{{ item.nums }}</div>
          </div>
        </transition-group>
      </div>
    </div>
    <div class="table" v-if="active == 2">
      <div class="thead">
        <div class="i-item rank">主题名称</div>
        <div class="i-item name">活动时间</div>
        <div class="i-item kcal">参与人次</div>
      </div>
      <div class="tbody" :class="count <= 5 ? 'high' : ''">
        <transition-group name="list" tag="div">
          <div class="item" v-for="(item, i) in p_list" :key="i">
            <div class="i-item rank">{{ item.title }}</div>
            <div class="i-item name">{{ item.date }}</div>
            <div class="i-item kcal">{{ item.joins }}</div>
            <div class="list" v-if="item.matchs.length">
              <div class="l-item" v-for="(row, index) in item.matchs" :key="index">
                <div class="ll-item rank">{{ row.title }}</div>
                <!-- <div class="ll-item name">{{ row.date }}</div> -->
                <div class="ll-item kcal">{{ row.joins }}</div>
              </div>
            </div>
          </div>
        </transition-group>
      </div>
    </div>
  </div>
</template>

<script>
let mtimer = null
let ltimer = null

export default {
  props: {
    count: {
      default: 10,
    },
    list1: {
      default() {
        return []
      },
    },
    list2: {
      default() {
        return []
      },
    },
  },
  data() {
    return {
      page_size: 9,

      active: 2,
      list: [],

      p_step: 0,
      c_step: 0,

      p_list: [],
      pList: [],
      c_list: [],
      cList: [],
    }
  },
  mounted() {
    mtimer = setInterval(() => {
      if (this.active == 1) {
        this.on_change(2)
      } else {
        this.on_change(1)
      }
    }, 20000)

    this.p_step = 0
    this.pList = this.list1
    this.$set(this, 'p_list', this.list1.slice(0, this.page_size))

    this.c_step = 0
    this.cList = this.list2
    this.$set(this, 'c_list', this.list2.slice(0, this.page_size))

    ltimer = setInterval(() => {
      this.p_list = []
      this.c_list = []

      setTimeout(() => {
        let p_step = this.p_step + 1

        // console.log(p_step, Math.floor(this.pList.length / this.page_size))

        if (p_step > Math.ceil(this.pList.length / this.page_size) - 1) {
          p_step = 0
        }

        this.p_list = this.pList.slice(this.page_size * p_step, this.page_size * p_step + this.page_size)

        this.p_step = p_step

        let c_step = this.c_step + 1

        if (c_step > Math.ceil(this.pList.length / this.page_size) - 1) {
          c_step = 0
        }

        this.c_list = this.cList.slice(this.page_size * c_step, this.page_size * c_step + this.page_size)

        this.c_step = c_step
      }, 600)
    }, this.page_size * 2000)
  },
  beforeDestroy() {
    clearInterval(mtimer)
  },
  methods: {
    on_change(i) {
      this.active = i
    },
  },
}
</script>

<style scoped>
.list-enter-active {
  transition: all 1s;
  transform-origin: top;
}

.list-leave-active {
  transition: all 0.4s;
  transform-origin: bottom;
}

.list-enter {
  opacity: 0;
  transform: rotateX(90deg);
}

.list-leave-to {
  opacity: 0;
  transform: rotateX(90deg);
}
</style>

<style lang="less" scoped>
.middle-bottom {
  .mhead {
    margin-top: -60px;
    padding: 13px 24px 20px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .item {
      font-size: 18px;
      color: #97b4ff;
      opacity: 0.33;
      &.active {
        opacity: 1;
      }
      & + .item {
        margin-left: 20px;
      }
    }
  }
  .table {
    margin: 20px 24px 0;
    .thead {
      display: flex;
      align-items: center;
      background: rgba(68, 96, 218, 0.2);
    }
    .tbody {
      height: 450px;
      overflow: auto;
      // &.high {
      //   height: 452px;
      // }
      .item {
        width: 100%;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        border-bottom: 1px solid rgba(68, 96, 218, 0.2);
        &:nth-of-type(even) {
          background: #002972;
        }
        .i-item {
          font-size: 14px;
          font-weight: normal;
          padding: 12px;
          color: #82a9ef;
        }
        .list {
          padding: 12px;
          border-top: 1px solid #2d60da;
          width: 100%;
          .l-item {
            display: flex;
            align-items: center;
            font-size: 12px;
            color: #d9e5ff;
            width: 100%;
            .ll-item {
              & + .ll-item {
                margin-top: 8px;
              }
              &.rank {
                width: 80%;
              }
              &.name {
                width: 30%;
                text-align: center;
                overflow: hidden; /* 超出部分隐藏 */
                white-space: nowrap; /* 文本不换行 */
                text-overflow: ellipsis; /* 省略的文本用省略号表示 */
              }
              &.kcal {
                text-align: center;
                width: 20%;
              }
            }
          }
        }
      }
    }
    .i-item {
      font-size: 16px;
      font-weight: 500;
      color: #00fbff;
      padding: 6px 12px;
      box-sizing: border-box;
      &.rank {
        width: 50%;
      }
      &.name {
        width: 30%;
        text-align: center;
        overflow: hidden; /* 超出部分隐藏 */
        white-space: nowrap; /* 文本不换行 */
        text-overflow: ellipsis; /* 省略的文本用省略号表示 */
      }
      &.grank {
        text-align: center;
        width: 15%;
      }
      &.gname {
        width: 65%;
      }
      &.kcal {
        text-align: center;
        width: 20%;
      }
    }
  }
}
</style>
